import {
    GET_ALL_WISHLISH,
    GET_WISHLISTBYID
} from "../actions/types";

const initialState = {
    wishList: {
        docs: [],
        totalDocs: 0,
        limit: 0,
        page: 0,
        totalPages: 0,
        pagingCounter: 0,
        hasPrevPage: false,
        hasNextPage: false,
        prevPage: null,
        nextPage: null,
    },
    loading: true,
    userWishListData: {},
};

const userWishListReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case GET_ALL_WISHLISH:
            return {
                ...state,
                wishList: payload,
                loading: false,
            };
        case GET_WISHLISTBYID:
            return {
                ...state,
                userWishListData: payload,
                loading: false,
            };

        //   case APPLY_PROPERTY:
        //     return {
        //       ...state,
        //       propertyData: payload,
        //       propertyLoading: false,
        //     };

        default:
            return state;
    }
};

export default userWishListReducer;
